enum DoorTypes {
  HasDoor,
  None,
  Curtain,
}

export default DoorTypes;
